import { tss } from 'tss-react';
import { spacing } from 'studio/helpers';
import { useTheme } from '@mui/material/styles';

// We need theme here and, because of the rules of hooks, we can't call `useTheme` inside the `tss.create` function.
// So we create a hook, then call `tss.create` inside it.
export default () => {
  const theme = useTheme();

  const createStyles = tss.create({
    email: {
      marginTop: theme.spacing(3)
    },
    emails: {
      marginTop: theme.spacing(1),
      '& .MuiChip-root': {
        marginRight: theme.spacing(1),
        marginBottom: theme.spacing(1)
      }
    },
    userType: {
      marginTop: theme.spacing(2)
    },
    updateWarning: {
      marginTop: theme.spacing(2),
      marginBottom: -spacing(theme, 2)
    }
  });

  return createStyles();
};
